module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showQuitModal) ? _c('div', {
    staticClass: "pop-recom"
  }, [_c('div', {
    staticClass: "pop-body",
    on: {
      "click": _vm.preventDefault
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("非常抱歉，本业务暂不支持办理，推荐办理更优惠产品: " + _vm._s(_vm.productName))])]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("点击查看" + _vm._s(_vm.time) + "s")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("温馨提示")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb3ce560!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecomBox.vue
// module id = 30
// module chunks = 4 63 64 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82 91 92 93 94 95 96 97 98 99 100 101 102 103 104 105 106 107 108 109 110 111 112 113 114 115 116 117 118 119 120 121 122 123 124 131 132 133 134 135 136 137